import { usePublicShareFlowsheet } from '../api/public-share-api';

export function PublicFlowsheet({ token }: { token: string }) {
  const { data, isLoading } = usePublicShareFlowsheet(token, true);
  if (isLoading) {
    return (
      <section className="rounded border p-4">
        <h3 className="text-base font-semibold">Flowsheet</h3>
        <p className="text-sm text-muted-foreground">Loading…</p>
      </section>
    );
  }
  return (
    <section className="rounded border p-4">
      <h3 className="mb-3 text-base font-semibold">Flowsheet</h3>
      <pre className="whitespace-pre-wrap text-xs text-muted-foreground">
        {JSON.stringify(data?.data ?? {}, null, 2)}
      </pre>
    </section>
  );
}
